import { Pipe, PipeTransform } from '@angular/core';
import Autolinker, { AutolinkerConfig } from 'autolinker';

/** Gjør lenker i angitt tekst klikkbare.
 * Benytter npm biblioteket https://github.com/gregjacobs/Autolinker.js til dette formålet.
 * Eksempel på bruk: <div [innerHTML]="en_tekst | linky"></div> */
@Pipe({name: 'linky', pure: true, standalone: true})
export class KlikkbareLenkerPipe implements PipeTransform {

    transform(tekst: string, options?: AutolinkerConfig): string {
        return Autolinker.link(tekst, options);
    }

}
